<template>
  <div style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">升禾智慧环卫系统</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <div class="model">
          <div class="model_title">【企业介绍】</div>

          <div class="section">
            广西升禾环保科技股份有限公司于2009年通过柳州市柳东新区招商局引资落户官塘创业园，是一家专业从事城市综合环境管理的创新型服务企业。在全体同仁共同努力下，公司于2014年5月30日成功在北京股转系统新三板挂牌上市(股权代码430761)。现注册资本为7524.3万元人民币，总资产过亿，并在全国范围内设立了超过30家分子公司，拥有员工近3500人，公司致力于成为一家从事市政道路清扫保洁、生活垃圾收运及转运服务、智慧环卫云服务、垃圾分类服务、餐厨垃圾收运及处置、专业城市环境综合解决方案设计、园林绿化养护、河道保洁服务等一体化综合性服务企业。公司拥有先进的环卫理念、完善的管理机制，雄厚的技术力量，拥有专业性强、工作效率高、服务素质好、高度责任心的专业团队。
          </div>
           <div class="section">
            <img src="../../assets/shenghe/case3.png" alt="" />
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目概况】</div>



          <div>
            <div class="section">
              升禾环保以专业技术为城市环卫事业（城市基础项目）提供一站式解决方案，如“技术咨询、方案设计、垃圾转运站（BOT）投资与设备融资、租赁”等专业优质的服务。为落实战略信息规划，公司提出了依托在环卫运营相关的经验、技术和市场领导地位，利用工业互联网、物联网（以下简称为IOT）、云计算、边缘计算、大数据、人工智能等新兴技术和科技支撑，建立环卫运维一体化平台的战略构想，为环卫运行、客户体验、服务质量、新商业模式推进等保驾护航。在未来将支撑升禾更多的服务业务、成为升禾未来服务收入的新的增长引擎。
              项目基于SAAS架构开发出具有自主知识产权的升禾环境云平台，创新业务与管理一体化的业务管理模式，实现智能化排班、智能优化和调整车辆作业路线、智能优化垃圾收运路线、智能优化垃圾桶布置、智能优化垃圾中转站管理及应急处理多系统智能化联动等“六大智能化管理”。.
            </div>
            <div class="section">
              <img src="../../assets/shenghe/case4.png" alt="" />
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            实现人工清扫和机械清扫排班、实时监管，降低反复行驶路程25%，，增效10%。
          </div>
          <div class="section">
            实现点检管理、巡检管理、预警管理，降低设备故障率20%以上，维修期缩短30%，油耗、水耗、调度人工成本、维护成本降低30%以上。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseTianjianDetail",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss">
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        img {
          width: 242px;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseShengHeDetail.vue